import  React from 'react';
import * as H from 'history';
import { Table } from '../../../../../shared/table';
import { OverseasRepresentativeDetails, OverseasRepresentativeColumns } from "./OverseasRepresentativeDetails";
import { SaveCancelButtons } from '../../../../applicationForm-1/controls/SaveCancelButtons';
import { MilestoneModel } from '../../../../../models/MilestoneModel'
import { OverseasRepresentativeModel } from '../../../../../models/OverseasRepresentativeModel'
import { MilestoneReportController } from '../../../../../controllers/MilestoneReportController';
import { ISupportSpinner } from '../../../../../shared/Ajax';
import { Backdrop } from '../../../../../shared/Backdrop';
import { Icon } from '../../../../../shared/Icon';
import { Option } from '../../../../../models/Option';


export interface OverseasRepresentativePageProps {
    history: H.History
    model: MilestoneModel
    onChange: { (changes: Partial<MilestoneModel>, callback?: { (): any }): any }
    addressCountries: Option<string>[]
}

export interface OverseasRepresentativePageState {
    loading: boolean
    overseasRepresentatives: OverseasRepresentativeModel[]
}

export class OverseasRepresentativePage extends React.Component<OverseasRepresentativePageProps, OverseasRepresentativePageState> implements ISupportSpinner {
    ajax: MilestoneReportController
    table: Table<OverseasRepresentativeModel>

    constructor(props: OverseasRepresentativePageProps) {
        super(props);

        this.ajax = new MilestoneReportController();

        this.state = {
            overseasRepresentatives: props.model ? props.model.overseasRepresentatives.map(r => r) : [],
            loading: false
        }
    }

    componentDidMount() {
        this.ajax.saveMilestoneReport(this, this.props.model,
            (d) => {
                this.props.onChange({ ...this.props.model, ...d });
            });
    }

    componentWillUnmount() {
        this.ajax.cancel();
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
        this.setState({ loading: on }, callback);
    }

    save = () => {
        this.table.saveAndClose(res => {
            if (res) {
                if (this.state.overseasRepresentatives.filter(r => r.invalid).length == 0) {
                    const updatedModel = { ...this.props.model, overseasRepresentatives: this.state.overseasRepresentatives }
                    this.ajax.updateOverseasRepresentative(this, updatedModel, (d) => {
                        this.props.onChange({...this.props.model, ...d})
                        this.props.history.goBack();
                    })
                }
                else {
                    alert("Please correct records marked with the warning sign.");
                }
            }
        });
    }

    render() {
        let columns = [...OverseasRepresentativeColumns];

        const invalidRows = this.state.overseasRepresentatives.filter(r => r.invalid).length > 0;
        if (invalidRows) {
            columns.splice(0, 0, { name: "", content: d => d.invalid ? <Icon type="warning" /> : <span /> });
        }

        var sortedList = this.state.overseasRepresentatives.slice();
        sortedList.sort((a, b) => a.invalid ? -1 : 1);

        return <>
            <SaveCancelButtons onCancel={this.props.history.goBack} onSave={this.save} />
            <h2 className="mt-3">Overseas Representatives</h2>
            <p className="mt-3 mb-3">Include all overseas representatives where the cost is AU$60,000 or more.</p>
            <p className="mt-3 mb-3">Enter the information in the provided fields. Please note there is no upload functionality for this question.</p>
            <Table<OverseasRepresentativeModel>
                id="table"
                label="Overseas Representatives"
                ref={r => this.table = r}
                value={sortedList}
                onChange={overseasRepresentatives => this.setState({ overseasRepresentatives })}
                columns={columns}
                renderSection={(p, i) => <OverseasRepresentativeDetails {...p} milestone={this.props.model} addressCountries={this.props.addressCountries} />}
                match={(a, b) => a.representativeID == b.representativeID}
                alwaysShowAllRows={true}
                invalidRows={invalidRows}
            />

            <SaveCancelButtons onCancel={this.props.history.goBack} onSave={this.save} />

            <Backdrop on={this.state.loading} />
        </>
    }
}